import { useEffect, useState } from 'react';
import axios from 'axios';

const apiUrl = "https://elcobradorleague.com/api";

export const usePlayerHonor = (idplayer, idleague) => {
  const [playerHonorData, setPlayerHonorData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!idplayer || !idleague) {
      setPlayerHonorData([]);
      setLoading(false);
      return;
    }

    setLoading(true);

    axios
      .get(`${apiUrl}/api.php?endpoint=playerhonor&idplayer=${idplayer}&idleague=${idleague}`)
      .then(res => {
        const data = Array.isArray(res.data) ? res.data : [];
        setPlayerHonorData(data);
      })
      .catch(err => {
        console.error("Error fetching player honors:", err);
        setError(err);
        setPlayerHonorData([]);
      })
      .finally(() => setLoading(false));

  }, [idplayer, idleague]);

  return { playerHonorData, loading, error };
};
